import { InputLabel, TextField } from '@mui/material'
import styled from 'styled-components'
import { COLORS, FONTS, TYPOGRAPHY } from 'utils'

interface NewInput {
  hasError?: boolean
}
export const InputCustom = styled(TextField)<NewInput>`
  border: none;
  .MuiInputBase-root:before {
    border-bottom: 0.1rem solid
      ${({ hasError }) => (hasError ? COLORS.error : COLORS.black)};
  }
  .MuiInputBase-root:after {
    border-bottom: 0.1rem solid
      ${({ hasError }) => (hasError ? COLORS.error : COLORS.blueFonts)};
  }

  .MuiInput-underline:hover:before {
    border-bottom: 0.1rem solid
      ${({ hasError }) => (hasError ? COLORS.error : COLORS.blueFonts)};
  }
`

export const InputLabelCustom = styled(InputLabel)<NewInput>`
  font-size: ${TYPOGRAPHY.bodySize14};
  font-weight: ${FONTS.regular};
  color: ${({ hasError }) => (hasError ? COLORS.error : COLORS.black)};
  font-family: Arial;
`
